(() => {
  'use strict';

  const normalizePath = (path) => {
    const normalized = (path || '/').replace(/\/+$/, '');
    return normalized || '/';
  };

  const finalizeDrawerState = (drawer, opener) => {
    const mainDetails = drawer.mainDetailsToggle || opener?.closest('details') || drawer.querySelector(':scope > details');
    if (!mainDetails) return;

    mainDetails.classList.remove('menu-opening');
    mainDetails.removeAttribute('open');
    opener?.setAttribute('aria-expanded', 'false');
  };

  const init = (root = document) => {
    root.querySelectorAll('header-drawer').forEach((drawer) => {
      if (drawer.dataset.egSamePageAnchorClose === 'true') return;
      drawer.dataset.egSamePageAnchorClose = 'true';

      drawer.addEventListener('click', (event) => {
        if (
          event.defaultPrevented ||
          event.button !== 0 ||
          event.metaKey ||
          event.ctrlKey ||
          event.shiftKey ||
          event.altKey
        ) {
          return;
        }

        const origin = event.target instanceof Element ? event.target : event.target?.parentElement;
        const link = origin?.closest('a[href*="#"]');

        if (!link || !drawer.contains(link) || link.target === '_blank' || link.hasAttribute('download')) return;

        let destination;
        try {
          destination = new URL(link.href, window.location.href);
        } catch (_error) {
          return;
        }

        if (
          destination.origin !== window.location.origin ||
          normalizePath(destination.pathname) !== normalizePath(window.location.pathname) ||
          !destination.hash
        ) {
          return;
        }

        let targetId;
        try {
          targetId = decodeURIComponent(destination.hash.slice(1));
        } catch (_error) {
          return;
        }

        if (!targetId || !document.getElementById(targetId)) return;

        const opener = drawer.querySelector(':scope > details > summary') || drawer.querySelector('summary');
        if (!opener || typeof drawer.closeMenuDrawer !== 'function') return;

        drawer.closeMenuDrawer(event, opener);
        finalizeDrawerState(drawer, opener);
      });
    });
  };

  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
